import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    max-width: 650px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject());
var Item = styled.div(_templateObject2());
export var Unauthorized = function Unauthorized() {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement("h1", null, "Unauthorized")), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement("p", null, "User not authorized for this application. Please contact admin to request access.")));
};